import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { MockProfileService, Follower } from '../../services-mock/mock-profile.service';

@Component({
  selector: 'app-followers',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, AvatarModule],
  template: `
    <div class="followers-container">
      <div class="followers-header">
        <button
          pButton
          type="button"
          icon="pi pi-arrow-left"
          label="Back"
          (click)="goBack()"
          class="back-button"
        ></button>
        <h2 class="followers-title">Followers</h2>
      </div>

      <div class="followers-list" *ngIf="followers.length > 0">
        <div *ngFor="let follower of followers" class="follower-item">
          <div class="follower-info">
            <p-avatar
              [label]="follower.initials"
              shape="circle"
              size="normal"
            ></p-avatar>
            <div class="follower-details">
              <div class="follower-name">{{ follower.name }}</div>
              <div class="follower-title">{{ follower.title }}</div>
              <div class="follower-company">{{ follower.company }}</div>
            </div>
          </div>
          <button
            pButton
            type="button"
            [label]="follower.isFollowing ? 'Following' : 'Follow'"
            [class.following]="follower.isFollowing"
            [class.follow]="!follower.isFollowing"
            (click)="toggleFollow(follower)"
          ></button>
        </div>
      </div>

      <div class="no-followers" *ngIf="followers.length === 0 && !loading">
        <div class="no-followers-content">
          <i class="pi pi-users no-followers-icon"></i>
          <h3>No followers yet</h3>
          <p>Start connecting with others to build your network!</p>
        </div>
      </div>

      <div class="loading" *ngIf="loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading followers...</span>
      </div>
    </div>
  `,
  styles: [
    `
      .followers-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 1.5rem;
        background-color: #f5f5f5;
        min-height: calc(100vh - 60px);
      }

      .followers-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.5rem;
      }

      .back-button {
        background: transparent;
        color: #666666;
        border: 1px solid #e5e5e5;
      }

      .followers-title {
        font-size: 1.75rem;
        font-weight: 600;
        color: #000000;
        margin: 0;
      }

      .followers-list {
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        overflow: hidden;
      }

      .follower-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.5rem;
        border-bottom: 1px solid #e5e5e5;
      }

      .follower-item:last-child {
        border-bottom: none;
      }

      .follower-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1;
      }

      .follower-details {
        display: flex;
        flex-direction: column;
      }

      .follower-name {
        font-weight: 600;
        font-size: 1rem;
        color: #000000;
        margin-bottom: 0.25rem;
      }

      .follower-title {
        font-size: 0.9rem;
        color: #666666;
        margin-bottom: 0.25rem;
      }

      .follower-company {
        font-size: 0.85rem;
        color: #999999;
      }

      .follow-button.follow {
        background: #0066cc;
        color: #ffffff;
        border: none;
      }

      .follow-button.following {
        background: transparent;
        color: #666666;
        border: 1px solid #e5e5e5;
      }

      .no-followers {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        padding: 3rem;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }

      .no-followers-content {
        text-align: center;
        max-width: 400px;
      }

      .no-followers-icon {
        font-size: 4rem;
        color: #cccccc;
        margin-bottom: 1rem;
      }

      .no-followers-content h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #000000;
        margin: 0 0 0.5rem 0;
      }

      .no-followers-content p {
        font-size: 1rem;
        color: #666666;
        margin: 0;
      }

      .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 3rem;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        color: #666666;
      }

      .loading i {
        font-size: 2rem;
      }
    `,
  ],
})
export class FollowersComponent implements OnInit {
  followers: Follower[] = [];
  loading = true;

  constructor(
    private profileService: MockProfileService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadFollowers();
  }

  loadFollowers() {
    this.loading = true;
    this.profileService.getFollowers().subscribe((followers) => {
      this.followers = followers;
      this.loading = false;
    });
  }

  toggleFollow(follower: Follower) {
    follower.isFollowing = !follower.isFollowing;
    // In a real app, this would call a service to update follow status
  }

  goBack() {
    this.router.navigate(['/profile']);
  }
}

